import {Button, ButtonGroup, Menu, MenuItem} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import PopupState, {bindMenu, bindTrigger} from 'material-ui-popup-state';
import {ReactNode, Component} from 'react';

import {UserDataModel} from '../Admin/UserData.Model';
import AuthService from '../Common/AuthService';

interface State {
	users: UserDataModel[];
}

class LoginAsButton extends Component<object, State> {
	private readonly authService: AuthService;

	public constructor(props: object) {
		super(props);
		this.authService = new AuthService();
		this.state = {
			users: [],
		};
	}

	public async componentDidMount(): Promise<void> {
		await this.loadUsers();
	}

	private async loadUsers(): Promise<void> {
		const users = await this.authService.getAllUsers();
		this.setState({users});
	}

	public render(): ReactNode {
		if (
			!this.authService.isAdmin() &&
			this.authService.getOriginalEmail() === ''
		) {
			return <></>;
		}

		if (this.authService.getOriginalEmail() !== '') {
			return (
				<Button
					variant='contained'
					color='secondary'
					onClick={(): void => {
						this.loginAsUser(this.authService.getOriginalEmail());
					}}
				>
					Zurückwechseln
				</Button>
			);
		}

		return (
			<PopupState variant='popover' popupId='login-as-user-menu'>
				{(popupState: Window): ReactNode => (
					<>
						<ButtonGroup variant='contained' color='secondary'>
							<Button>Anmelden als</Button>
							<Button
								color='secondary'
								size='small'
								{...bindTrigger(popupState)}
							>
								<ArrowDropDownIcon />
							</Button>
						</ButtonGroup>
						<Menu {...bindMenu(popupState)}>
							{this.state.users.map(
								(user): ReactNode => (
									<MenuItem
										key={user.email}
										onClick={(): void => {
											this.loginAsUser(user.email);
											popupState.close();
										}}
									>
										{user.email}
									</MenuItem>
								)
							)}
						</Menu>
					</>
				)}
			</PopupState>
		);
	}

	private loginAsUser(email: string): void {
		this.authService.loginAs(email).then(() => {
			window.location.href = '/';
		});
	}
}

export default LoginAsButton;
